import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { ApiResponse } from '../../../types/apiResponse';
import withPrefix from '../../../helpers/useQueryPrefix';
import type { ClientData } from '../types';
import { fetchClientById } from '../api/fetchClientById';

export const useFetchClientById = (id_client?: number | null): UseQueryResult<ClientData, Error> => {
	return useQuery<ApiResponse<ClientData>, Error, ClientData>({
		queryKey: withPrefix(['client', id_client]),
		queryFn: () => fetchClientById(id_client as number),
		select: (response) => {
			if (response.status !== 200) {
				throw new Error(response.message);
			}
			return response.data as ClientData;
		},
		enabled: !!id_client,
	});
};
